import React from "react";
import ContextMenuWrapper from "./common/ContextMenuWrapper.jsx";
import IncrDecrInput from "./common/IncrDecrInput.jsx";
import ToolTip from "./common/ToolTip";
import Select from './common/Select';
import Toggle from "react-toggle";
import { DropdownIndicator } from "../utils/dropdown-override";
import ColorPickerDot from "./color-picker/ColorPickerDot.js";

class AnnotationContextMenu extends React.Component {
    constructor(props) {
        super(props);
        let Dyn = props.Dyn,
            textSize = Dyn.plotUtil.textAnnotationSizeMin,
            textSizeOptions = [];
        for( let i = Dyn.plotUtil.textAnnotationSizeMin, increment = 1;
            i <= Dyn.plotUtil.textAnnotationSizeMax;
            i += increment ) {
            increment = (i < 16) ? 1 : (i < 30) ? 2 : 5;
            textSizeOptions.push({ label: i, value: i });
            if( i <= props.textSize ) {
                textSize = i; // start with the closest option to current text size
            }
        }
        let lockOptions = [
            { label:"none", value:false },
            { label:"locked", value:true },
            { label:"locked-movable", value:"moveOK" }];
        if( props.isText ) {
            lockOptions.push({ label:"locked-text-editable", value:"textEditOK" });
        }
        this.state = {
            textSize: textSize,
            isFilled: props.isFilled,
            textSizeOptions: textSizeOptions,
            lineWidth: props.lineWidth,
            lineWidthOptions: Dyn.dataUtil.indexArray( Dyn.plotUtil.annotationLineWidthMax-props.lineWidthMin+1, props.lineWidthMin )
                .map( (n) => ({ label:n, value:n })),
            smoothing: props.smoothing,
            smoothingOptions: Dyn.dataUtil.indexArray( Dyn.plotUtil.pencilSmoothingMax+1, Dyn.plotUtil.pencilSmoothingMin )
                .map( (n) => ({ label:n, value:n })),
            layerNum: props.layerNum,
            layerOptions: props.layerOptions.map( (n) => ({ label:n, value:n })),
            lock: props.lock,
            lockOptions: lockOptions,
        };
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc(str);
    };

    render = () => {
        let { Dyn } = this.props;
        return (
            <ContextMenuWrapper {...this.props} isColorPickerEnable={true}>
                <ContextMenuWrapper.Options>
                    <div>
                        <p className="tde-p-2 ted-pl-1 tde-mb-1 tde-mt-2 tde-ml-1 tde-m-0 tde-font-weight-bold">
                            { this.getLoc(this.props.isText ?"Text Annotation Options":"Annotation Options")}
                        </p>
                        {this.props.isText && (
                        <div className="tde-px-1">
                            <div className="tde-px-2 tde-pb-2 tde-pt-2 tde-d-flex tde-flex-items-center tde-justify-space-between">
                                <label className="text-normal">
                                    {this.getLoc("Text Size")}
                                    <span className="flex-1">
                                        <ToolTip
                                            tip={this.getLoc(
                                                "Increase or decrease the annotation font size"
                                            )}
                                            Dyn={Dyn}
                                        >
                                            <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <IncrDecrInput
                                    label={"Font Size"}
                                    onChange={(fontSize) => {
                                        this.setState({ textSize: fontSize });
                                        this.props.handleChange( { textSize: fontSize }, "textSize" );
                                    }}
                                    getLoc={this.getLoc}
                                    value={this.state.textSize}
                                    options={this.state.textSizeOptions}
                                ></IncrDecrInput>
                            </div>
                        </div>
                        )}

                        <div className="tde-p-2 tde-mx-1 tde-d-flex tde-flex-items-center tde-justify-space-between">
                            <label className="text-normal">
                                { this.getLoc(this.props.isText ? "Text Color":"Color") }
                            </label>
                            <ColorPickerDot
                                color={this.props.colorHex}
                                colorsArray={this.props.colorsArray}
                                onChange={(color) => {
                                    this.props.handleChange(color, "fgColor");
                                }}
                                Dyn={Dyn} />
                        </div>

                        {(typeof this.state.isFilled === 'boolean') && <div className="tde-p-2 tde-mx-1 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                            <label className="text-normal">
                                <span className="flex-1">
                                    {this.getLoc("Fill")}
                                    <ToolTip tip={this.getLoc( "Fill in the annotation/text background" )} Dyn={Dyn} >
                                            <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                    </ToolTip>
                                </span>
                            </label>
                            <Toggle
                                aria-label={this.getLoc("Fill Color")}
                                checked={this.state.isFilled}
                                id="tde-global-grid-lines-toggle"
                                className="black-toggle"
                                icons={false}
                                onChange={(e) => {
                                    this.props.handleChange( {isFilled: e.target.checked}, "isFilled" );
                                    this.setState({isFilled: e.target.checked});
                                }}
                            />
                        </div>}

                        {this.props.isText && (
                            <div className="tde-p-2 tde-mx-1 tde-d-flex tde-flex-items-center tde-justify-space-between">
                                <label className="text-normal">
                                    { this.getLoc("Fill Color") }
                                </label>
                                <ColorPickerDot
                                    color={this.props.bgColor}
                                    colorsArray={this.props.colorsArray}
                                    onChange={(color) => {
                                        this.props.handleChange(color, "bgColor");
                                        // Enable filled flag
                                        if(!this.state.isFilled) {
                                            this.props.handleChange({isFilled: true}, "isFilled");
                                            this.setState({isFilled: true});
                                        }
                                    }}
                                    Dyn={Dyn} />
                            </div>
                        )}

                        <div className="tde-border-top tde-my-1"></div>

                        <div className="tde-px-1">
                            <div className="tde-px-2 tde-pb-2 tde-pt-2 tde-d-flex tde-flex-items-center tde-justify-space-between">
                                <label className="text-normal">
                                    {this.getLoc("Line Width")}
                                    <span className="flex-1">
                                        <ToolTip tip={this.getLoc( "Increase or decrease the annotation line width" )} Dyn={Dyn} >
                                            <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <IncrDecrInput
                                    label={"Line Width"}
                                    onChange={(lineWidth) => {
                                        this.setState({ lineWidth: lineWidth });
                                        this.props.handleChange( { lineWidth: lineWidth }, "lineWidth" );
                                        // Turn of fill when line width is set
                                        if(this.state.isFilled && !this.props.isText) {
                                            this.props.handleChange({isFilled: false}, "isFilled");
                                            this.setState({isFilled: false});
                                        }
                                    }}
                                    getLoc={this.getLoc}
                                    value={this.state.lineWidth}
                                    options={this.state.lineWidthOptions}
                                ></IncrDecrInput>
                            </div>
                        </div>

                        {this.props.allowSmoothing && (
                        <div className="tde-px-1">
                            <div className="tde-px-2 tde-pb-2 tde-pt-2 tde-d-flex tde-flex-items-center tde-justify-space-between">
                                <label className="text-normal">
                                    {this.getLoc("Smoothing")}
                                    <span className="flex-1">
                                        <ToolTip tip={this.getLoc( "Increase or decrease smoothing of the pencil line" )} Dyn={Dyn} >
                                            <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <IncrDecrInput
                                    label={"Smoothing"}
                                    onChange={(lineWidth) => {
                                        this.setState({ smoothing: lineWidth });
                                        this.props.handleChange( { smoothing: lineWidth }, "smoothing" );
                                    }}
                                    getLoc={this.getLoc}
                                    value={this.state.smoothing}
                                    options={this.state.smoothingOptions}
                                ></IncrDecrInput>
                            </div>
                        </div>
                        )}

                        <div className="tde-px-1">
                            <div className="tde-px-2 tde-pb-2 tde-pt-2 tde-d-flex tde-flex-items-center tde-justify-space-between">
                                <label className="text-normal">
                                    {this.getLoc("Layer")}
                                    <span className="flex-1">
                                        <ToolTip tip={this.getLoc( "Move to the back (-) or front (+)" )} Dyn={Dyn} >
                                            <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <IncrDecrInput
                                    label={"Layer"}
                                    onChange={(layerNum) => {
                                        this.setState({ layerNum: layerNum });
                                        this.props.handleChange( { layerNum: layerNum }, "layerNum" );
                                    }}
                                    getLoc={this.getLoc}
                                    value={this.state.layerNum}
                                    options={this.state.layerOptions}
                                ></IncrDecrInput>
                            </div>
                        </div>

                        {this.props.allowLock && (
                        <div className="tde-px-1">
                            <div className="tde-px-2 tde-pb-2 tde-pt-2 tde-d-flex tde-flex-items-center tde-justify-space-between">
                                <label className="text-normal">
                                    {this.getLoc("Locked")}
                                    <span className="flex-1">
                                        <ToolTip tip={this.getLoc( "Lock the annotation to prevent further editing" )} Dyn={Dyn} >
                                            <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <Select
                                    Dyn={this.props.Dyn}
                                    aria-label={this.getLoc('Choose between data colors for visibility')}
                                    className="tde-input tde-flex-1 tde-select-input tde-input-select tde-data-colors tde-select-right"
                                    isClearable={false}
                                    value={this.state.lockOptions.find(
                                        (obj) => obj.value === this.state.lock
                                    )}
                                    options={this.state.lockOptions}
                                    // openMenuOnFocus
                                    onChange={(select) => {
                                        this.setState({ lock: select.value });
                                        this.props.handleChange( { lock: select.value }, "lock" );
                                    }}
                                    isSearchable={false}
                                    tabSelectsValue={false}
                                    placeholder={<div className='tde-select-placeholder'>{this.getLoc('Select')+'...'}</div>}
                                    components={{
                                        Option: ({ data, innerProps, children, innerRef, isSelected, isFocused }) => (
                                            <div className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')} role="listitem" aria-label={data.title} title={data.title} {...innerProps} ref={innerRef}>
                                                <div className="tde-s1">{children}</div>
                                            </div>
                                        ),
                                        DropdownIndicator
                                    }}
                                />
                            </div>
                        </div>
                        )}

                    </div>
                </ContextMenuWrapper.Options>
            </ContextMenuWrapper>
        );
    };
}

export default AnnotationContextMenu;
